/**
 * Progressive-enhancement layer for RSV forms (docs/CLAUDE.md Phase 9
 * §48-49): the form works fine as a classic POST without any of this —
 * these are pure UX additions. Disables the submit button after click
 * to prevent accidental double-submission, and moves focus to the
 * first server-reported error so keyboard/screen-reader users land
 * exactly where they need to fix something.
 */
export function initFormEnhance() {
  document.querySelectorAll('form').forEach((form) => {
    const submitButton = form.querySelector('[data-rsv-form-submit]');

    if (submitButton) {
      form.addEventListener('submit', () => {
        // Let the native submit proceed; only disable on the next tick
        // so the button's own value/state is still part of the POST.
        window.setTimeout(() => {
          submitButton.disabled = true;
          submitButton.textContent = submitButton.dataset.loadingText || submitButton.textContent;
        }, 0);
      });
    }
  });

  const firstError = document.querySelector('.rsv-field--error [aria-invalid="true"]');
  if (firstError) {
    // The redirect back to the form carries a #kontaktformular fragment
    // (so the form is scrolled into view even without this script) —
    // the browser's own "scroll to fragment" handling runs around the
    // same time as DOMContentLoaded and can reset focus to <body>
    // afterwards if we focus the field too early. Deferring one tick
    // ensures our focus call is the last one to run.
    window.setTimeout(() => firstError.focus(), 0);
  }
}
